import { ref, watch } from "vue";


const state = ref({
    course: null,
    participants: [{
        address: {},
    }],
    invoiceParticipant: {},
    otherInvoicePerson: {},
    invoiceContact: {},
    invoicePerson: '',
    keepMeUpdated: false,
});

state.init = function (key) {
    const storageKey = `course-flow-state-${key}`;

    if (sessionStorage?.getItem(storageKey)) {
        const stored = sessionStorage.getItem(storageKey)
        state.value = JSON.parse(stored)
    }

    watch(state, (newState) => {
        sessionStorage?.setItem(storageKey, JSON.stringify(newState))
    },
        { deep: true })
}

export default state;